// Message Detail Panel Sub-components
export { MessageHeader } from "./MessageHeader";
export { MessageMetadata } from "./MessageMetadata";
export { MessageContent } from "./MessageContent";
export { MessageActions } from "./MessageActions";
export { ContactContextCard } from "./ContactContextCard";
export { MessageRelatedTab } from "./MessageRelatedTab";

// Gmail-like Action Components
export { MessageDesktopActions } from "./MessageDesktopActions";
export { MessageDesktopInlineActions } from "./MessageDesktopInlineActions";
export { MessageMobileActions } from "./MessageMobileActions";
export { MessageMobileHeaderActions } from "./MessageMobileHeaderActions";
export { MessageActionsMenu } from "./MessageActionsMenu";

// Unified Action System
export { ActionButton, ACTION_CONFIGS } from "./ActionButton";
export type { ActionButtonConfig } from "./ActionButton";

// Hooks
export { useMessageActionHandlers } from "./hooks/useMessageActionHandlers";
export type { MessageActionHandlers } from "./hooks/useMessageActionHandlers";
